/**
 * NewAssetMonitorUserEvents
 * Registry of events for the New Asset Monitor pages
 */
export enum NewAssetMonitorUserEvents {
    FilterSearch = "New Asset Monitor - Filter - Search",
    FilterAssetClass = "New Asset Monitor - Filter - Asset Class",
    FilterPlatform = "New Asset Monitor - Filter - Platform",
    FilterNetwork = "New Asset Monitor - Filter - Network",
    GroupingChange = "New Asset Monitor - Grouping - Change",
    FilterClearAll = "New Asset Monitor - Filter - Clear All",
    IssuanceGroupToggle = "New Asset Monitor - Issuance Group - Toggle",
}
